import { JsonFormsCellRendererRegistryEntry, JsonFormsRendererRegistryEntry } from '@jsonforms/core';
import MantineBooleanControl, { mantineBooleanControlTester } from './controls/MantineCheckbox';
import {
  MantineLabelRenderer,
  MantineListWithDetailRenderer,
  mantineLabelRendererTester,
  mantineListWithDetailTester,
  Hidden,
  hiddenTester,
} from './additional';
import {
  MantineBooleanCell,
  mantineBooleanCellTester,
  MantineEnumCell,
  mantineEnumCellTester,
  MantineIntegerCell,
  mantineIntegerCellTester,
  MantineNumberCell,
  mantineNumberCellTester,
  MantineNumberFormatCell,
  mantineNumberFormatCellTester,
  MantineOneOfEnumCell,
  mantineOneOfEnumCellTester,
  MantineTextCell,
  mantineTextCellTester,
} from './cells';
import {
  MantineArrayLayoutRenderer,
  MantineCategorizationStepperLayoutRenderer,
  MantineGroupLayoutRenderer,
  MantineHorizontalLayoutRenderer,
  MantineVerticalLayoutRenderer,
  mantineArrayLayoutTester,
  mantineCategorizationStepperTester,
  mantineGroupTester,
  mantineHorizontalLayoutTester,
  mantineVerticalLayoutTester,
} from './layout';
import {
  MantineOneOfRenderer,
  mantineOneOfControlTester,
  MantineOneOfSelectRenderer,
  mantineOneOfSelectControlTester,
} from './complex';
import {
  MantineAnyOfStringOrEnumControl,
  mantineAnyOfStringOrEnumControlTester,
  MantineColorPicker,
  mantineColorPickerControlTester,
  MantineEnumControl,
  mantineEnumControlTester,
  MantineIntegerControl,
  mantineIntegerControlTester,
  MantineNativeControl,
  mantineNativeControlTester,
  MantineNumberControl,
  mantineNumberControlTester,
  MantineOneOfEnumControl,
  mantineOneOfEnumControlTester,
  MantineSliderControl,
  mantineSliderControlTester,
  MantineTextControl,
  mantineTextControlTester,
} from './controls';
import MantineObjectRenderer, { mantineObjectControlTester } from './complex/MaterialObjectRenderer';

export const mantineRenderers: JsonFormsRendererRegistryEntry[] = [
  // controls
  {
    tester: mantineBooleanControlTester,
    renderer: MantineBooleanControl,
  },
  { tester: mantineNativeControlTester, renderer: MantineNativeControl },
  { tester: mantineEnumControlTester, renderer: MantineEnumControl },
  { tester: mantineIntegerControlTester, renderer: MantineIntegerControl },
  { tester: mantineNumberControlTester, renderer: MantineNumberControl },
  { tester: mantineTextControlTester, renderer: MantineTextControl },
  { tester: mantineSliderControlTester, renderer: MantineSliderControl },
  { tester: mantineObjectControlTester, renderer: MantineObjectRenderer },
  {
    tester: mantineOneOfEnumControlTester,
    renderer: MantineOneOfEnumControl,
  },
  {
    tester: mantineColorPickerControlTester,
    renderer: MantineColorPicker,
  },
  // layouts
  {
    tester: mantineHorizontalLayoutTester,
    renderer: MantineHorizontalLayoutRenderer,
  },
  {
    tester: mantineVerticalLayoutTester,
    renderer: MantineVerticalLayoutRenderer,
  },
  {
    tester: mantineOneOfControlTester,
    renderer: MantineOneOfRenderer,
  },
  {
    tester: mantineOneOfSelectControlTester,
    renderer: MantineOneOfSelectRenderer,
  },
  {
    tester: mantineGroupTester,
    renderer: MantineGroupLayoutRenderer,
  },
  {
    tester: mantineCategorizationStepperTester,
    renderer: MantineCategorizationStepperLayoutRenderer,
  },
  { tester: mantineArrayLayoutTester, renderer: MantineArrayLayoutRenderer },
  // additional
  {
    tester: mantineLabelRendererTester,
    renderer: MantineLabelRenderer,
  },
  {
    tester: mantineAnyOfStringOrEnumControlTester,
    renderer: MantineAnyOfStringOrEnumControl,
  },
  {
    tester: mantineListWithDetailTester,
    renderer: MantineListWithDetailRenderer,
  },
  { tester: hiddenTester, renderer: Hidden },
];

export const mantineCells: JsonFormsCellRendererRegistryEntry[] = [
  { tester: mantineBooleanCellTester, cell: MantineBooleanCell },
  { tester: mantineEnumCellTester, cell: MantineEnumCell },
  { tester: mantineIntegerCellTester, cell: MantineIntegerCell },
  { tester: mantineNumberCellTester, cell: MantineNumberCell },
  { tester: mantineNumberFormatCellTester, cell: MantineNumberFormatCell },
  { tester: mantineOneOfEnumCellTester, cell: MantineOneOfEnumCell },
  { tester: mantineTextCellTester, cell: MantineTextCell },
];
